import { render, staticRenderFns } from "./Csr.vue?vue&type=template&id=56a33cd2&scoped=true"
import script from "./Csr.vue?vue&type=script&lang=js"
export * from "./Csr.vue?vue&type=script&lang=js"
import style0 from "./Csr.vue?vue&type=style&index=0&id=56a33cd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a33cd2",
  null
  
)

export default component.exports